import React, { useEffect,useRef, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './BusinessMyDeal.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import ProgressBar from "../../LinearProgressBar";
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import moment from "moment";
import { gettoastwarning, gettoastsuccess } from '../../../Utils/Common';
import Modal from 'react-bootstrap/Modal';
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "./firebase";
import {validateforotp} from '../../../Utils/validate';


const BusinessMyDeal = () => {
    const [loading, setLoading] = useState(true);
    const [errors,setErrors] = useState({});

    const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputRefs = useRef([]);


    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);

    const [deleteid, setDeleteid] = useState(0);

    const handleClose = () => setShow(false);
    const handleClose2 = () => setShow2(false);

    const [current_page, setCurrentpage] = useState(1);
    const [last_page, setLastpage] = useState(1);

    const [deal, setDeal] = useState([]);
    const [slug, setSlug] = useState('');

    //const [inputslnk, setInputslnk] = useState({ url: '' });
    
    const [guidelines, setGuidelines] = useState();
    const [inputs, setInputs] = useState({ id: '', business_name: '', email: '', address: '', contact_number: '', image: '', business_unique_id: '', profile_per: 0,is_phone_verified:0 });
    const [cat, setCat] = useState([]);
    useEffect(() => {
        document.title = `Business My Deal | Local Bells`;
        document.getElementById('bodywrap').className = 'busimydeal';


        /* Start get deal */
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        API.post('get_my_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setSlug(response.data.data.business.slug);
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get deal */
        /* Start get profile */
        let formData1 = new FormData();
        formData1.append(`business_id`, localStorage.getItem("business_id"));
        API.post('get_business_detail', formData1)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                } else {
                    var image = '';
                    if (response.data.data.profile[0]) {
                        image = response.data.data.profile[0].name;
                    }
                    setInputs({
                        id: response.data.data.id,
                        business_name: response.data.data.business_name,
                        email: response.data.data.email,
                        address: response.data.data.address,
                        contact_number: response.data.data.business_contact_number,
                        image: image,
                        business_unique_id: response.data.data.business_unique_id,
                        profile_per: response.data.data.profile_per,
                        is_phone_verified:response.data.data.is_phone_verified
                    });
                    setCat(response.data.data.categories);

                    /*var url = process.env.REACT_APP_BASE_URL + 'neighbour/business-details/' + response.data.data.business_name;
                    setInputslnk({ url: url });*/

                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get profile */

        /* Start guidelines */    
        API.post('get_deal_guidelines')
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                }else{
                    setGuidelines(response.data.data);
                }
            }).catch(error => {
                
            });
        /* End get guidelines */

    }, []);
    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };
    const getdeal = () => {
        setLoading(true);
        var currentpage = current_page + 1;
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`per_page`, 8);
        formData.append(`page`, currentpage);
        API.post('get_my_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);
                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const delete_modal_deal = (id) => {
        setDeleteid(id);
        setShow(true);
    }
    
   
    
    const delete_deal = () => {
        setLoading(true);
        setShow(false);
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`deal_id`, deleteid);
        API.post('delete_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                    gettoastwarning(response.data.message, '');
                } else {
                    gettoastsuccess(response.data.message, '/business/my-deal');

                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    }
    const handleStatus = (e, id) => {
        const isChecked = e.target.checked;
        var status = 0;
        if (isChecked) {
            status = 1;
        }
        setDeal((prevDeals) =>
            prevDeals.map((item) =>
                item.deal_id === id ? { ...item, status: isChecked } : item
            )
        );
        setLoading(true);
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`deal_id`, id);
        formData.append(`type`, 'active_status');
        formData.append(`status`, status);
        API.post('update_status_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                    gettoastwarning(response.data.message, '');
                } else {
                    gettoastsuccess(response.data.message, '');
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    }
    const shareAll = () => {
        const url = `${process.env.REACT_APP_BASE_URL}neighbour/business-details/${slug}`;

        navigator.clipboard.writeText(url)
            .then(() => {
                gettoastsuccess('Link copied to clipboard', '');
            })
            .catch(err => {
                console.error('Failed to copy:', err);
            });
    }

 const sendOtp = () => {
     setLoading(true);
  const container = document.getElementById("recaptcha-container");
  if (!container) {
    console.error("reCAPTCHA container missing");
    setLoading(false);
    return;
  }

  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      { size: "invisible" }
    );
  }

  const phoneNumber = "+91"+inputs.contact_number;
  const appVerifier = window.recaptchaVerifier;

  signInWithPhoneNumber(auth, phoneNumber, appVerifier)
    .then((confirmationResult) => {
      window.confirmationResult = confirmationResult;
      //alert("OTP Sent");
        setLoading(false);
        setShow2(true);
    })
    .catch((error) => {
        setLoading(false);
        let errorMessage = 'Something went wrong. Please try again.';
        switch (error.code) {
            case 'auth/invalid-phone-number':
                errorMessage = 'Invalid phone number. Please enter a valid number.';
                break;
            case 'auth/quota-exceeded':
                errorMessage = 'Too many requests. Please try again later.';
                break;
            case 'auth/user-disabled':
                errorMessage = 'This user has been disabled. Contact support.';
                break;
            case 'auth/too-many-requests':
                errorMessage = 'Too many attempts. Please wait before retrying.';
                break;
            default:
                errorMessage = error.message; // Firebase provides specific messages
                break;
        }
        gettoastwarning(errorMessage, '');
      //console.error(error);
      //alert(error.message);
    });
 }

const verifyOtp = () => {
    setLoading(true);
   const validationErrors = validateforotp(otp);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors(validationErrors);
  if(noErrors){
    var ot='';
    otp.forEach((item, index) => {
      ot+=item;
    })
      window.confirmationResult.confirm(ot)
        .then((result) => {
          //console.log("User:", result.user);
          //alert("OTP Verified");
            update_phone_status();
        })
        .catch(() => {
            setLoading(false);
            gettoastwarning("Invalid OTP", '');
        });
    }
};

const update_phone_status = () => {
    setLoading(true);
    let formData = new FormData();
    formData.append(`business_id`, localStorage.getItem("business_id"));
    formData.append(`is_phone_verified`, 1);
    API.post('update_phone_status', formData)
        .then(response => {
            setLoading(false);
            if (response.data.status === false) {
                gettoastwarning(response.data.message, '');
            } else {
                setShow2(false);
                gettoastsuccess(response.data.message, '/business/my-deal');
            }
        }).catch(error => {
            setLoading(false);
            gettoastwarning("Something went wrong. Please try again later.", '');
        });
}
 
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (otp[index] === '') {
                if (index > 0) {
                    inputRefs.current[index - 1].focus();
                }
            } else {
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            }
        }
    };





    const handleChange = (element, index) => {
        const value = element.value.replace(/[^0-9]/g, ''); // Only digits
        if (value) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move to next input
            if (index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='mdeal-single'>
                                    <div className='mds-bot'>
                                        <Row>
                                            <h2 className='fw-500 md-mob-title'>{inputs.business_name}</h2>
                                            {inputs.image ?
                                                <Col xs={12} md="auto" className='align-items-center d-flex'>
                                                    <Image src={inputs.image} className="img-fluid bmd-img" alt="cdeal5" />
                                                </Col> : <Col xs={12} md="auto" className='align-items-center d-flex'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/placeimage.png'} className="img-fluid bmd-img" alt="cdeal5" />
                                                </Col>}
                                            <Col xs={12} md className='mds-mid-cont bmd-mid-cont'>
                                                <h5 className='fw-500'>{inputs.business_name}</h5>
                                                <h6 className='bu-id'>Business ID : <span className='fw-600'>{inputs.business_unique_id}</span></h6>
                                                <div className='mds-loc'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt={inputs.business_name} />
                                                    <h6>{inputs.address}</h6>
                                                </div>
                                                <div className="d-flex gap-2 flex-row-reverse flex-md-row justify-content-between align-items-center">
                                                    <div className='mds-cat d-flex align-items-center'>
                                                        <h6>Category</h6>
                                                        <div>
                                                            {cat.map((val, index) => (
                                                                <h6 key={index}>{val.name}</h6>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <div className="edit-icon-mobile cursor-pointer d-block d-md-none mb-2">
                                                        <Link to="/business/edit-business">
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-last.svg'} className="img-fluid" alt="edit" style={{ width: '32px', height: '32px' }} />
                                                        </Link>
                                                    </div>
                                                    <div className="edit-icon-mobile cursor-pointer m-share-btn d-block d-md-none mb-2">
                                                        <Link to="#" onClick={shareAll} className='me-3'><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th-blc.webp'} className="img-fluid" alt="share-th" /></Link>
                                                    </div>
                                                    
                                                </div>
                                            </Col>
                                            <Col xs={12} md className='mds-right bmd-right'>
                                                <div className='md-link-box-top'>
                                                    <div>
                                                        <ProgressBar value={inputs.profile_per} />
                                                        <h6 className='fw-600 text-uppercase'>{inputs.profile_per}% Competed</h6>
                                                        <Link className='fw-600' to="/business/edit-business">
                                                            Finish Profile Setup
                                                        </Link>
                                                    </div>
                                                    <Link to="#" onClick={shareAll} className='blue-link md-share-link dd-share me-3'><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th.webp'} className="img-fluid" alt="share-th" /></Link>
                                                    <Link to="/business/edit-business" className='md-edit-link '>
                                                        <h6>Edit</h6>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-whi.webp'} className="img-fluid" alt="edit-whi" />
                                                    </Link>
                                                </div>
                                                <h6>Business email :  <span className='fw-600'>{inputs.email}</span></h6>
                                                <h6>Business contact :  <span className='fw-600'>{inputs.contact_number}
                                                    {/* <span onClick={mobile_verify}>verify</span> */}
                                                </span> 
                                                <div id="recaptcha-container"></div>
                                                <p>
                                                {inputs.is_phone_verified === 0 ? (
                                                <span className="ctv" onClick={sendOtp}>
                                                  Click to verify
                                                </span>
                                              ) : (
                                                <span className="veri">
                                                  Verified
                                                </span>
  )}    
                                          </p>

                                                </h6>
                                              
                                                <h6>Membership :  <span className='fw-600'> Premium </span></h6>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className='mds-detail'>
                                        <Row>
                                            <Col>
                                                <h3>{inputs.business_name}</h3>
                                            </Col>
                                            <Col xs={3}>
                                                <div className='mds-icn'>
                                                    <Link onClick={shareAll}>
                                                        <img src={process.env.REACT_APP_BASE_URL + 'assets/images/share-th-blc.webp'} class="" alt="" />
                                                    </Link>
                                                    <Link to="/business/edit-business">
                                                        <img src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-last.svg'} class="" alt="" />
                                                    </Link>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <ul>
                                                    {cat.map((val, index) => (
                                                        <li key={index}>{val.name}</li>
                                                    ))}
                                                </ul>
                                                <p className='mds-membership'>Membership : <span>Premium</span></p>
                                            </Col>
                                            <Col md={12}>
                                                {inputs.image ?
                                                    <Image src={inputs.image} className="img-fluid mds-profile bmd-img-mob" alt="cdeal5" />
                                                    :
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/placeimage.png'} className="img-fluid bmd-img-mob" alt="cdeal5" />
                                                }
                                                <h6 className='bu-id'>Business ID : <span className='fw-600'>{inputs.business_unique_id}</span></h6>
                                                <div className='mds-icn-box'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="cdeal5" />
                                                    <h6>{inputs.address}</h6>
                                                </div>
                                                <div className='mds-icn-box'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/email.webp'} className="img-fluid" alt="cdeal5" />
                                                    <h6>{inputs.email}</h6>
                                                </div>
                                                <div className='mds-icn-box'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/phone.webp'} className="img-fluid  " alt="cdeal5" />
                                                    <h6>{inputs.contact_number}</h6>


                                                    {inputs.is_phone_verified === 0 ? (
                                                <h5 className='ctv' onClick={sendOtp}>Click to verify</h5>
                                              ) : (
                                                <h5 className='veri'>Verified</h5>
                                                )}

                                                    
                                                    
                                                </div>
                                                <div>
                                                    <ProgressBar value={inputs.profile_per} />
                                                    <div className='d-flex'>
                                                        <h6 className='fw-600 text-uppercase'>{inputs.profile_per}% Competed</h6>
                                                        <Link className='fw-600 ms-3' to="/business/edit-business">
                                                            Finish Profile Setup
                                                        </Link>                                                    
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                </div>

                                <div className='deal-guideline'>
                                                                        
                                     <div
                                        dangerouslySetInnerHTML={{
                                            __html: guidelines
                                        }}
                                    ></div>                                                                                                                     
                                </div>
                                

                                <div className='bd-name'>
                                    <div>
                                        <h3>My Deals</h3>
                                    </div>
                                    <Link to="/business/new-deal" className='blue-icn-btn and-btn'><h6 className='text-capitalize'>Add new deal</h6> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/add-wh.webp'} className="img-fluid" alt="add-wh" /> </Link>
                                </div>
                                {deal.length > 0 && (
                                    <Row>
                                        {deal.map((val, index) => {
                                            return (
                                                <Col xs={6} md={6} lg={6} xl={4} xxl={3} className={`cd-single-main bu-md ${val.admin_approve ? "" : "blurred-div"}`}>
                                                    {val.status === 0 || val.status === false ? (
                                                        <span className="red-label">Inactive</span>
                                                    ) : val.admin_approve === 0 ? (
                                                        <span className="red-label">Under Review</span>
                                                    ) : val.admin_approve === 1 ? (
                                                        <span className="gre-label">Active</span>
                                                    ) : val.admin_approve === 2 ? (
                                                        <span className="red-label">Rejected</span>
                                                    ) : val.admin_approve === 3 ? (
                                                        <span className="red-label">Scheduled</span>
                                                    ) : val.admin_approve === 4 ? (
                                                        <span className="red-label">Expired</span>
                                                    ) : null}
                                                    <div className='cd-single-box'>
                                                        <div className="cd-single-small-box">
                                                            <Link to={`/business/business-deal-details/${val.deal_id}`} className="d-block mb-3">
                                                            <Image src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} className="img-fluid deal-img-height" alt="cdeal4" />
                                                            </Link>
                                                            <div className='md-top-box'>
                                                                <h6>Deal ID :  <span>#{val.deal_unique_id}</span></h6>
                                                                {/*<div className='d-flex align-center csb-title'>
                                                            <div className='d-flex'><strike className="me-2"><h5>Rs. 60</h5></strike><h5>Rs. 30</h5></div>
                                                            <h6 class="peroff">50% off</h6>
                                                        </div> */}
                                                                {(() => {
                                                                    if (val.deal_master_type === 'specific') {
                                                                        if (val.deal_type === 1) {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><strike className="me-2"><h5>Rs. {val.original_mrp}</h5></strike><h5>Rs. {val.sale_price}</h5></div>
                                                                                <h6 class="peroff">{val.discount}% off</h6>
                                                                            </div>)
                                                                        } else if (val.deal_type === 2) {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                            </div>)
                                                                        }
                                                                    } else if (val.deal_master_type === 'general') {
                                                                        if (val.deal_type === 3) {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                            </div>)
                                                                        } else if (val.deal_type === 4) {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                            </div>)
                                                                        }
                                                                    } else if (val.deal_master_type === 'free') {
                                                                        return (<div className='d-flex align-center csb-title'>
                                                                            <div className='d-flex'><h5 className="text-danger">FREE Shaving</h5></div>
                                                                        </div>)
                                                                    }
                                                                })()}
                                                                <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                {/*<div><h6>{val.description}</h6></div>*/}
                                                            </div>
                                                            <div className='md-switch-main'>
                                                                <div className='md-switch-box'>
                                                                    <div>
                                                                        <h6>Active</h6>
                                                                        <Form.Check
                                                                            type="switch"
                                                                            id="notifications"
                                                                            checked={val.status}
                                                                            onChange={(e) => handleStatus(e, val.deal_id)}
                                                                        />
                                                                    </div>
                                                                    <p className=''><b>Sold</b> - <span>{val.total_deal_per_month !== "Unlimited"
      ? `${val.deal_clips_this_month}/${val.total_deal_per_month}`
      : val.total_deal_per_month}</span></p>
                                                                    {val.deal_end_date !== '' && (
                                                                        <p className='cd-exp'>Expire on : {moment(val.deal_end_date).format("D MMMM, YYYY")}</p>
                                                                    )}
                                                                </div>
                                                                {/*<div className='md-switch-box'>
                                                        <div>
                                                            <h6>Promote</h6>
                                                            <Form.Check
                                                                type="switch"
                                                                id="notifications"
                                                                onChange={handleSwitchChange}
                                                            />
                                                        </div>
                                                        <p className='cd-exp'>Ends : 30 May, 2025</p>
                                                    </div>*/}
                                                            </div>
                                                        </div>
                                                        <div className='md-link-box'>
                                                            <Link to="#" className='md-del-link' onClick={() => delete_modal_deal(val.deal_id)}>
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/del-whi.webp'} className="img-fluid" alt="del-whi" />
                                                            </Link>
                                                            {(() => {
                                                                if (val.deal_master_type === 'free') {
                                                                    return (
                                                                        <Link to={`/business/edit-freeitem-sale/${val.deal_id}`} className='md-edit-link md-edit-link-dis'>
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-whi.webp'} className="img-fluid" alt="edit-whi" />
                                                                        </Link>
                                                                    )
                                                                } else if (val.deal_master_type === 'specific') {
                                                                    return (
                                                                        <Link to={`/business/edit-product-sale/${val.deal_id}`} className='md-edit-link md-edit-link-dis'>
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-whi.webp'} className="img-fluid" alt="edit-whi" />
                                                                        </Link>
                                                                    )
                                                                } else if (val.deal_master_type === 'general') {
                                                                    return (
                                                                        <Link to={`/business/edit-store-sale/${val.deal_id}`} className='md-edit-link md-edit-link-dis'>
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-whi.webp'} className="img-fluid" alt="edit-whi" />
                                                                        </Link>
                                                                    )
                                                                }
                                                            })()}
                                                        </div>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                )}
                                {current_page !== last_page && (
                                    <Row className="text-center load-more">
                                        <Col md={12}>
                                            <Link to="#" className="blue-link" onClick={getdeal}>Load More</Link>
                                        </Col>
                                    </Row>
                                )}
                                <div className='footer-org footer mt-5'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                
            </section>
            <Modal
                size="md"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className='deal-modal'
                centered
            >
                <Modal.Header closeButton={false}>
                </Modal.Header>
                <Modal.Body>
                    <h5 className="mb-5">Do you want to permanently delete this deal?</h5>
                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={delete_deal}>
                            Delete
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                size="md"
                show={show2}
                onHide={handleClose2}
                backdrop="static"
                keyboard={false}
                centered
                className="new-modal otp-modal"
                >
                <Modal.Header className="border-0 pb-0">
                    <h5 className="modal-title">OTP Verification</h5>
                </Modal.Header>
 
                <Modal.Body>
                    <p className="mb-3">
                    Please enter the 6 digit OTP sent to your mobile number
                    </p>
 
                    <Form>
                    <div className="d-flex justify-content-between otp-box-wrapper mb-4">
                        {[...Array(6)].map((_, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="otp-box"
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (inputRefs.current[index] = el)}
                            />
                        ))}
                    </div>
                    {errors.otp && (<p className="text-danger text-start mb-1">{errors.otp}</p>)}
                    <div className="d-flex justify-content-end gap-3">
                        <Button className='sub-close' onClick={handleClose2}>
                        Cancel
                        </Button>
                        <Button className='btn sub-submit' onClick={verifyOtp}>
                        Verify OTP
                        </Button>
                    </div>
                    </Form>
                </Modal.Body>
            </Modal>
            {loading && (<div className="loadingClass"><img src={loader} alt="loader" /></div>)}
        </>
    )
}
export default BusinessMyDeal;


